import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { AuthenticationNgRxActions } from '@geekbears/gb-ngrx-auth-basic';
import { getFailureMessageRxOp } from '@geekbears/gb-ngrx-stack-base';
import { NotificationsService } from '@geekbears/ngx-gb-ui-kit';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { User } from '@sentry/angular';
import { isNil } from 'lodash';
import { filter, map, Observable, Subject, takeUntil, tap } from 'rxjs';

import {
  addCompanyFailureAction,
  addCompanySuccessAction,
  CompanyActions,
  addCompanyLoadingSelector,
} from '@modules/super-admin/company/application';
import { Company } from '@modules/super-admin/company/domain';
import { Industries } from '@utils/industries';

@Component({
  selector: 'app-company-information',
  templateUrl: './company-information.page.html',
  styleUrls: ['./company-information.page.scss'],
})
export class CompanyInformationComponent implements OnInit, OnDestroy {
  @ViewChild('templateBottomSheet') TemplateBottomSheet!: TemplateRef<any>;
  /**
   * @destroy$ is used to unsubscribe from all subscriptions
   */
  destroy$: Subject<void> = new Subject();
  form!: FormGroup;
  addressForm!: FormGroup;
  companyFrom!: FormGroup;
  addCompanyLoading$: Observable<boolean | any>;
  industries = Industries;
  companyName: string = '';
  currentUser!: User;
  isDisabled: boolean = false;
  constructor(
    private store$: Store,
    private actions$: Actions,
    private fb: FormBuilder,
    private notificationService: NotificationsService,
    private router: Router,
    private bottomSheet: MatBottomSheet
  ) {
    this.addCompanyLoading$ = this.store$
      .select(addCompanyLoadingSelector)
      .pipe(
        tap((status) => {
          if (status) this.isDisabled = true;
        })
      );

    this.buildCompanyForm();
    this.getCompanyNameFromLocalStorage();
  }

  ngOnInit(): void {
    this.getCurrentUser();
    this.onFailureActions();
    this.actions$
      .pipe(
        ofType(addCompanySuccessAction),
        filter((action: any) => {
          return !isNil(action);
        }),
        map((action: any) => {
          if (action)
            setTimeout(() => {
              this.isDisabled = false;
            }, 1500);
          this.notificationService.success('Company Successfully Added', {
            duration: 3000,
            icon: 'check-circle',
          });
          this.setCompanyToUser(action.response.data);
          setTimeout(() => {
            this.router.navigateByUrl('/authentication/pick-plan');
          }, 2000);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
  setCompanyToUser(company: Company) {
    let currentUser = JSON.parse(localStorage.getItem('s_user') || '{}');
    if (currentUser) {
      currentUser.company = company;
      currentUser._companyId = company.id;
      localStorage.setItem('s_user', JSON.stringify(currentUser));
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  save() {
    this.addressForm
      .get('zip')
      ?.setValue(this.addressForm.get('zip')?.value.toString());

    if (
      this.companyFrom.valid &&
      this.addressForm.valid &&
      this.isDisabled == false
    ) {
      this.companyFrom.get('address')?.setValue(this.addressForm.value);

      this.store$.dispatch(
        CompanyActions.addCompany({
          company: this.companyFrom.value,
        })
      );
    }
  }
  onFailureActions() {
    this.actions$
      .pipe(
        ofType(addCompanyFailureAction),
        map((action) => {
          return action.failure;
        }),
        getFailureMessageRxOp(),
        tap((errorMessage) => {
          this.isDisabled == false;
          if (errorMessage) {
            this.notificationService.error(errorMessage, {
              duration: 5000,
              icon: 'alert-outline',
            });
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  buildCompanyForm() {
    this.addressForm = this.fb.group({
      street1: ['', Validators.required],
      street2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', [Validators.required, Validators.minLength(5)]],
      country: ['', Validators.required],
    });

    this.companyFrom = this.fb.group({
      industry: [''],
      address: [],
    });
  }
  getCompanyNameFromLocalStorage() {
    this.companyName =
      JSON.parse(localStorage.getItem('s_user') || '{}').companyName || '';
  }
  openBottomSheet() {
    this.bottomSheet.open(this.TemplateBottomSheet);
  }

  closeTemplateSheetMenu() {
    this.bottomSheet.dismiss();
  }
  logOut() {
    this.bottomSheet.dismiss();
    // localStorage.clear();
    localStorage.removeItem('s_admin');
    localStorage.removeItem('confirmAccountToken');
    localStorage.removeItem('confirmAccountEmail');
    this.store$.dispatch(AuthenticationNgRxActions.logout());
  }
  getCurrentUser() {
    this.currentUser = JSON.parse(localStorage.getItem('s_user') || '{}');
  }
}
